import { render } from "./Loading.vue?vue&type=template&id=c8366f7e&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=c8366f7e&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-c8366f7e"

export default script